<div class="position-relative w-100 padding">
    <app-header-detail></app-header-detail>
    <app-sub-detail></app-sub-detail>
    <app-app-detail></app-app-detail>
</div>
